/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-05-19 10:47:29
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-12-09 13:43:47
 * @FilePath: \betdoce-admind:\new_project\betdoce-web\src\api\customer-service.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import request from "./request";
import type {
  CustomerQuestionResponse,
  TelegramGroupLinkResponse,
  ChatRequest,
  ChatResponse,
  ServiceLinkResponse,
} from "@/types/customer-service";

// 获取常见问题列表
export const getCustomerQuestions = () => {
  return request.Get<CustomerQuestionResponse>("/getQuestion/keywordTop");
};
// 获取热门问题列表
export const getCustomerHotQuestions = () => {
  return request.Get<CustomerQuestionResponse>(
    "/customer/service/hot/questions/list",
    {
      params: { _v: Date.now() },
    }
  );
};
// 获取Telegram群组邀请链接
export const getTelegramGroupInviteLink = () => {
  return request.Get<TelegramGroupLinkResponse>(
    "/question/getTelegramGroupInviteLink"
  );
};

// 发送消息
export const sendChatMessage = (data: ChatRequest) => {
  return request.Post<ChatResponse>("/question/chat", data);
};

// 用户提问
export const sendCustomerAsk = (data: ChatRequest) => {
  return request.Post<ChatResponse>("/customer/service/ask", data);
};

// 获取客服群
export const customerServiceGroups = () => {
  return request.Get("/tg/customerServiceGroups", {
    params: { _v: Date.now() },
  });
};

// 获取WhatsApp
export const whatsappLink = () => {
  return request.Get("/whatsapp/link");
};

// 获取服务链接
export const fetchServiceLink = () => {
  return request.Get<ServiceLinkResponse>("/customer/service/join");
};

export interface InsRewardStatusData {
  new_user_reward_claimed: boolean;
  recharge_reward_claimed: boolean;
  new_user_reward_amount: number;
  recharge_reward_amount: number;
}

export const fetchInsRewardStatus = () => {
  return request.Get<InsRewardStatusData>("/ins-reward/status", {
    params: { _v: Date.now() },
  });
};

// 获取订阅号
export const subscriptions = () => {
  return request.Get("/tg/subscriptions", {
    params: { _v: Date.now() },
  });
};

// 获取欢迎语
export const getWelcomeResponses = () => {
  return request.Get("/question/getWelcomeResponses");
};

// 获取移动端欢迎语
export const getCustomerServiceConfig = () => {
  return request.Get("/customer/service/config");
};

// 获取帮助中心类别组列表
export const getHelpCenterLists = () => {
  return request.Get("/help/center/category/group/list", {
    params: { _v: Date.now() },
  });
};

// 上传文件
export const uploadFiles = (data: any) => {
  return request.Post("/user/upload/file", data, {
    headers: {},
  });
};

// 用户提交反馈内容
export const fetchSubmit = (data: any) => {
  return request.Post("/user/feedback", data);
};

// 获取反馈配置信息
export const fetchFeedbackConfig = () => {
  return request.Get("/feedback/config", {
    params: { _v: Date.now() },
  });
};
